export default [
    {
        name:'authorize',
        path:'authorize',
        meta: { title: '系统授权' },
        component: ()=>import('@/pages/authorize/index.vue')
    }
]